import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { YOUTUBE_API_URL_TOKEN } from '../tokens';

@Injectable()
export class YoutubeApiService {
  private initialized = false;
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(YOUTUBE_API_URL_TOKEN) private apiUrl: string,
  ) {
    if (window.YT) {
      this.initialized = true;
      return;
    }

    this.renderer = this.rendererFactory.createRenderer(null, null);

    this.inject();
  }

  private inject() {
    if (this.initialized) {
      return;
    }

    const tag = this.renderer.createElement('script');

    tag.src = this.apiUrl;

    this.renderer.appendChild(document.body, tag);

    this.initialized = true;
  }
}
